// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__H_1IU","article__body":"styles_article__body__fxqrs","h2":"styles_h2__iDpQU","h3":"styles_h3__a9Df6"};